export default {
  methods: {
    getArticleLazyloadImage(img, w, h, color, opacity) {
      return {
        src: img || `/image/placeholder/${w}/${h}/${color}/${opacity}`,
        error: `/image/placeholder/${w}/${h}/${color}/${opacity}`,
        loading: `/image/placeholder/${w}/${h}/${color}/${opacity}`,
      }
    },
  },
}



// WEBPACK FOOTER //
// ./components/mixins/lazyloadImage.js